import React from "react";
import PropTypes from "prop-types";
import { Button } from "../../ui";
import "./FilterEmptyState.scss";

const FilterEmptyState = ({
  title = "No results found",
  message = "Nothing matches your current filters. Try broadening your search or clear filters to see more.",
  onClearFilters,
  showClearAction = true,
  variant = "card",
  className = "",
}) => (
  <div
    className={[
      "filter-empty-state",
      `filter-empty-state--${variant}`,
      className,
    ]
      .filter(Boolean)
      .join(" ")}
    role="status"
    aria-live="polite"
  >
    <div className="filter-empty-state__icon-wrap" aria-hidden="true">
      <i className="material-icons filter-empty-state__icon">
        {variant === "feed" ? "filter_alt_off" : "search_off"}
      </i>
    </div>
    <h3 className="filter-empty-state__title">{title}</h3>
    <p className="filter-empty-state__message">{message}</p>
    {showClearAction && onClearFilters && (
      <Button
        type="button"
        theme="accent"
        className="filter-empty-state__action"
        onClick={onClearFilters}
      >
        Clear filters
      </Button>
    )}
  </div>
);

FilterEmptyState.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  onClearFilters: PropTypes.func,
  showClearAction: PropTypes.bool,
  variant: PropTypes.oneOf(["card", "feed"]),
  className: PropTypes.string,
};

export default FilterEmptyState;
